module.exports = __webpack_public_path__ + "img/repv2.ab45cdcc.svg";